import { axiosNodeInstance } from "../../../adapters/axiosInstance";
import { GET_CITY } from "./cityTypes";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCity = createAsyncThunk(GET_CITY, async ({ active } = {}) => {
    const url = active !== undefined ? `state_city?active=${active}` : "state_city";
    const response = await axiosNodeInstance.get(url);
    return response.data.ServiceCity;
});
